import React, { useEffect } from "react";
import {
  createBrowserRouter,
  RouterProvider,
  ScrollRestoration,
  Outlet,
} from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import HomePage from "./pages/HomePage";
import NewsPage from "./pages/NewsPage";
import NewsDetail from "./pages/NewsDetail";
import NewsletterPage from "./pages/NewsletterPage";
import LocalTendersPage from "./pages/LocalTendersPage";
import OurOdysseyPage from "./pages/OurOdysseyPage";
import BoardOfDirectorsPage from "./pages/BoardOfDirectorsPage";
import DirectorDetailPage from "./pages/DirectorDetailPage";
import SeniorManagementPage from "./pages/SeniorManagementPage";
import SeniorManagementDetailPage from "./pages/SeniorManagementDetailPage";
import CorporateGovernancePage from "./pages/CorporateGovernancePage";
import QualityPage from "./pages/QualityPage";
import SafetyPriorityPage from "./pages/SafetyPriorityPage";
import EnergyManagementPage from "./pages/EnergyManagementPage";
import CSREnvironmentPage from "./pages/CSREnvironmentPage";
import AwardsPage from "./pages/AwardsPage";
import TestimonialPage from "./pages/TestimonialsPage";
import KeyStrengthsPage from "./pages/KeyStrengthsPage";
import ShipRepairsPage from "./pages/Shiprepairspage";
import ShipbuildingPage from "./pages/Shipbuildingpage";
import AfloatRepairsPage from "./pages/AfloatRepairspage";
import OffshoreEngineeringPage from "./pages/Offshoreengineeringpage";
import HeavyEngineeringPage from "./pages/HeavyEngineeringPage";
import OEMsInColomboPage from "./pages/OEMsInColomboPage";

import WorkingAtCDL from "./pages/WorkingAtCDL";
import WhatWeOffer from "./pages/WhatWeOffer";
import TrainingPage from "./pages/TrainingPage";
import RecognitionPage from "./pages/RecognitionPage";
import Opportunities from "./pages/Opportunities";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import HelpFAQ from "./pages/HelpFAQ";
import Tenders from "./pages/Tenders";
import Milestone from "./pages/Milestone";
import ShipyardLayout from "./pages/ShipyardLayout";
import DrydocksPage from "./pages/DrydocksPage";
import WorkshopsPage from "./pages/WorkshopsPage";
import ClassificationSocietiesPage from "./pages/ClassificationSocietiesPage";
import SustainabilityPage from "./pages/SustainabilityPage";

import NotFoundPage from "./pages/NotFoundPage";
import BackToTop from "./components/BackToTop";
import Chatbot from "./components/Chatbot";

import ContactUsPage from "./pages/ContactUsPage";
import AnnualReportsPage from "./pages/AnnualReportsPage";
import InvestorRelationsPage from "./pages/InvestorRelationsPage";
import StatisticsPage from "./pages/StatisticsPage";
import Shipyard360 from "./pages/Shipyard360";

import AgentsPage from "./pages/AgentsPage";
// Layout component to enable ScrollRestoration
const Layout = () => {
  return (
    <>
      <ScrollRestoration />
      <Outlet />
      <BackToTop />
      <Chatbot />
    </>
  );
};

const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      { path: "/", element: <HomePage /> },
      { path: "/news", element: <NewsPage /> },
      { path: "/main-news", element: <NewsPage /> },
      { path: "/main-news.html", element: <NewsPage /> },
      { path: "/news/:slug", element: <NewsDetail /> },
      { path: "/newsletter", element: <NewsletterPage /> },
      { path: "/tenders", element: <LocalTendersPage /> },
      { path: "/local-tenders", element: <LocalTendersPage /> },
      { path: "/about", element: <OurOdysseyPage /> },
      { path: "/about/our-odyssey", element: <OurOdysseyPage /> },
      { path: "/about/board", element: <BoardOfDirectorsPage /> },
      { path: "/board-of-directors", element: <BoardOfDirectorsPage /> },
      { path: "/board-of-directors/:slug", element: <DirectorDetailPage /> },
      { path: "/about/management", element: <SeniorManagementPage /> },
      {
        path: "/senior-management-team/:slug",
        element: <SeniorManagementDetailPage />,
      },
      { path: "/about/governance", element: <CorporateGovernancePage /> },
      {
        path: "/corporate-governance.html",
        element: <CorporateGovernancePage />,
      },
      { path: "/about/quality", element: <QualityPage /> },
      { path: "/quality.html", element: <QualityPage /> },
      { path: "/about/safety", element: <SafetyPriorityPage /> },
      { path: "/safety-is-priority.html", element: <SafetyPriorityPage /> },
      { path: "/about/energy", element: <EnergyManagementPage /> },
      { path: "/energy-management.html", element: <EnergyManagementPage /> },
      { path: "/about/csr", element: <CSREnvironmentPage /> },
      { path: "/csr-environment.html", element: <CSREnvironmentPage /> },
      { path: "/sustainability", element: <SustainabilityPage /> },
      { path: "/sustainability.html", element: <SustainabilityPage /> },
      { path: "/about/awards", element: <AwardsPage /> },
      { path: "/awards.html", element: <AwardsPage /> },
      { path: "/about/testimonials", element: <TestimonialPage /> },
      { path: "/testimonial.html", element: <TestimonialPage /> },
      { path: "/about/strengths", element: <KeyStrengthsPage /> },
      { path: "/key-strength.html", element: <KeyStrengthsPage /> },

      // Services routes
      { path: "/services", element: <ShipRepairsPage /> },
      { path: "/services/ship-repairs", element: <ShipRepairsPage /> },
      { path: "/ship-repairs.html", element: <ShipRepairsPage /> },
      { path: "/services/shipbuilding", element: <ShipbuildingPage /> },
      { path: "/shipbuilding.html", element: <ShipbuildingPage /> },
      { path: "/services/afloat-repairs", element: <AfloatRepairsPage /> },
      { path: "/afloat-repairs.html", element: <AfloatRepairsPage /> },
      { path: "/services/offshore", element: <OffshoreEngineeringPage /> },
      {
        path: "/offshore-engineering.html",
        element: <OffshoreEngineeringPage />,
      },
      {
        path: "/services/heavy-engineering",
        element: <HeavyEngineeringPage />,
      },
      { path: "/heavy-engineering.html", element: <HeavyEngineeringPage /> },
      { path: "/services/oems", element: <OEMsInColomboPage /> },
      { path: "/oem's-in-colombo.html", element: <OEMsInColomboPage /> },

      // Facilities routes
      { path: "/facilities", element: <ShipyardLayout /> },
      { path: "/shipyard-layout", element: <ShipyardLayout /> },
      { path: "/shipyard-layout.html", element: <ShipyardLayout /> },
      { path: "/drydocks", element: <DrydocksPage /> },
      { path: "/drydocks.html", element: <DrydocksPage /> },
      { path: "/workshops", element: <WorkshopsPage /> },
      { path: "/workshops.html", element: <WorkshopsPage /> },
      {
        path: "/classification-societies",
        element: <ClassificationSocietiesPage />,
      },
      {
        path: "/classification-societies.html",
        element: <ClassificationSocietiesPage />,
      },

      // Other routes
      { path: "/agents", element: <AgentsPage /> },
      { path: "/agents.html", element: <AgentsPage /> },
      { path: "/financials", element: <AnnualReportsPage /> },
      { path: "/annual-reports.html", element: <AnnualReportsPage /> },
      { path: "/investor-relations.html", element: <InvestorRelationsPage /> },
      // { path: "/statistics.html", element: <StatisticsPage /> },
      { path: "/privacy-policy.html", element: <PrivacyPolicy /> },
      { path: "/HelpFAQ.html", element: <HelpFAQ /> },
      { path: "/tenders.html", element: <Tenders /> },
      { path: "/milestone.html", element: <OurOdysseyPage /> },
      { path: "/ourtimeline.html", element: <Milestone /> },
      { path: "/working-at-colombo-dockyard", element: <WorkingAtCDL /> },
      { path: "/working-at-colombo-dockyard.html", element: <WorkingAtCDL /> },
      { path: "/what-we-offer.html", element: <WhatWeOffer /> },
      { path: "/training.html", element: <TrainingPage /> },
      { path: "/recognition-of-employees.html", element: <RecognitionPage /> },
      { path: "/opportunities.html", element: <Opportunities /> },
      { path: "/contact-us", element: <ContactUsPage /> },
      { path: "/contact-us.html", element: <ContactUsPage /> },
      { path: "/home-annual-reports", element: <AnnualReportsPage /> },
      { path: "/blog-news", element: <NewsPage /> },
      { path: "/our-odyssey.html", element: <OurOdysseyPage /> },
      { path: "/shipyard-360", element: <Shipyard360 /> },

      // 404 - must be last
      { path: "*", element: <NotFoundPage /> },
    ],
  },
]);

function App() {
  useEffect(() => {
    // Enable copy/paste functionality site-wide
    const enableCopy = () => {
      document.body.oncopy = null;
      document.body.oncut = null;
      document.body.onpaste = null;
      document.oncontextmenu = null;

      const style = document.createElement("style");
      style.innerHTML =
        "* { user-select: text !important; -webkit-user-select: text !important; }";
      document.head.appendChild(style);
    };

    const timer = setTimeout(enableCopy, 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      offset: 50,
    });
  });

  return <RouterProvider router={router} />;
}

export default App;
